// removed by extract-text-webpack-plugin
module.exports = {"tax-price":"app-components-receipt-refunds-RefundBreakdownModal-Tax-__Tax___wm4EH","tax-padding-left":"app-components-receipt-refunds-RefundBreakdownModal-Tax-__Tax___2ZKrV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/RefundBreakdownModal/Tax/Tax.css
// module id = 2246
// module chunks = 0